// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasty-container {
  padding: 0.5rem;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}

.tasty-header {
  margin-bottom: 1rem;
}

.tasty-header h2 {
  margin: 0;
  color: #333;
  font-size: 2rem;
}

.tasty-header p {
  margin: 0.5rem 0 0 0;
  color: #666;
}

.tasty-content {
  width: 100%;
  box-sizing: border-box;
}

.tasty-controls {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.tasty-period-selector,
.tasty-open-close-selector,
.tasty-buy-sell-selector,
.tasty-symbol-filter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tasty-period-selector label,
.tasty-open-close-selector label,
.tasty-buy-sell-selector label,
.tasty-symbol-filter label {
  font-weight: 500;
  color: #333;
}

.tasty-period-selector select,
.tasty-open-close-selector select,
.tasty-buy-sell-selector select,
.tasty-symbol-filter input {
  padding: 8px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
  min-width: 150px;
}

.tasty-symbol-filter input {
  cursor: text;
}

.tasty-period-selector select:focus,
.tasty-open-close-selector select:focus,
.tasty-buy-sell-selector select:focus,
.tasty-symbol-filter input:focus {
  outline: none;
  border-color: #667eea;
}

.tasty-summary {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  font-size: 0.95rem;
  color: #555;
}

.tasty-summary strong {
  color: #333;
}

.tasty-summary .positive {
  color: #2e7d32;
  font-weight: 700;
}

.tasty-summary .negative {
  color: #d32f2f;
  font-weight: 700;
}

.tasty-table-container {
  overflow-x: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.tasty-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  table-layout: auto;
}

.tasty-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.tasty-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
}

.tasty-table tbody tr {
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
}

.tasty-table tbody tr:hover {
  background-color: #f9f9f9;
}

.tasty-table tbody tr:last-child {
  border-bottom: none;
}

.tasty-table td {
  padding: 10px 8px;
  font-size: 0.85rem;
  text-align: left;
}

.tasty-account-cell {
  font-weight: 500;
  color: #667eea;
}

.tasty-date-cell {
  font-weight: 500;
  color: #333;
  font-family: 'Courier New', monospace;
  white-space: nowrap;
}

.tasty-symbol-cell {
  font-weight: 600;
  color: #333;
}

.tasty-underlying-cell {
  color: #777;
  font-size: 0.8rem;
}

.tasty-buy-sell-cell {
  font-weight: 600;
  text-transform: uppercase;
}

.tasty-buy-sell-cell.buy {
  color: #2e7d32;
}

.tasty-buy-sell-cell.sell {
  color: #d32f2f;
}

.tasty-open-close-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.tasty-open-close-badge.open {
  background: #e3f2fd;
  color: #1565c0;
}

.tasty-open-close-badge.close {
  background: #ede7f6;
  color: #5e35b1;
}

.tasty-number-cell {
  text-align: left;
  font-family: 'Courier New', monospace;
  color: #555;
}

.tasty-number-cell.positive {
  color: #2e7d32;
  font-weight: 600;
}

.tasty-number-cell.negative {
  color: #d32f2f;
  font-weight: 600;
}

.tasty-number-cell.muted {
  color: #aaa;
}

.tasty-pnl-note {
  display: block;
  font-size: 0.7rem;
  color: #999;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.tasty-loading, .tasty-error, .tasty-empty-state {
  text-align: center;
  padding: 3rem 2rem;
  font-size: 1.1rem;
}

.tasty-error {
  color: #d32f2f;
  background-color: #ffebee;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
}

.tasty-empty-state {
  color: #666;
  background: white;
  border-radius: 8px;
  padding: 4rem 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

@media (max-width: 1200px) {
  .tasty-table th,
  .tasty-table td {
    padding: 8px 5px;
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .tasty-container {
    padding: 0.25rem;
  }

  .tasty-table-container {
    font-size: 0.75rem;
  }

  .tasty-table th,
  .tasty-table td {
    padding: 6px 4px;
    font-size: 0.75rem;
  }

  .tasty-underlying-cell {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Tasty.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;EAIE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".tasty-container {\n  padding: 0.5rem;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.tasty-header {\n  margin-bottom: 1rem;\n}\n\n.tasty-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 2rem;\n}\n\n.tasty-header p {\n  margin: 0.5rem 0 0 0;\n  color: #666;\n}\n\n.tasty-content {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.tasty-controls {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  display: flex;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.tasty-period-selector,\n.tasty-open-close-selector,\n.tasty-buy-sell-selector,\n.tasty-symbol-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.tasty-period-selector label,\n.tasty-open-close-selector label,\n.tasty-buy-sell-selector label,\n.tasty-symbol-filter label {\n  font-weight: 500;\n  color: #333;\n}\n\n.tasty-period-selector select,\n.tasty-open-close-selector select,\n.tasty-buy-sell-selector select,\n.tasty-symbol-filter input {\n  padding: 8px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  min-width: 150px;\n}\n\n.tasty-symbol-filter input {\n  cursor: text;\n}\n\n.tasty-period-selector select:focus,\n.tasty-open-close-selector select:focus,\n.tasty-buy-sell-selector select:focus,\n.tasty-symbol-filter input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.tasty-summary {\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n  font-size: 0.95rem;\n  color: #555;\n}\n\n.tasty-summary strong {\n  color: #333;\n}\n\n.tasty-summary .positive {\n  color: #2e7d32;\n  font-weight: 700;\n}\n\n.tasty-summary .negative {\n  color: #d32f2f;\n  font-weight: 700;\n}\n\n.tasty-table-container {\n  overflow-x: auto;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.tasty-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 0;\n  table-layout: auto;\n}\n\n.tasty-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.tasty-table th {\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.tasty-table tbody tr {\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s ease;\n}\n\n.tasty-table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n.tasty-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.tasty-table td {\n  padding: 10px 8px;\n  font-size: 0.85rem;\n  text-align: left;\n}\n\n.tasty-account-cell {\n  font-weight: 500;\n  color: #667eea;\n}\n\n.tasty-date-cell {\n  font-weight: 500;\n  color: #333;\n  font-family: 'Courier New', monospace;\n  white-space: nowrap;\n}\n\n.tasty-symbol-cell {\n  font-weight: 600;\n  color: #333;\n}\n\n.tasty-underlying-cell {\n  color: #777;\n  font-size: 0.8rem;\n}\n\n.tasty-buy-sell-cell {\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tasty-buy-sell-cell.buy {\n  color: #2e7d32;\n}\n\n.tasty-buy-sell-cell.sell {\n  color: #d32f2f;\n}\n\n.tasty-open-close-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.tasty-open-close-badge.open {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.tasty-open-close-badge.close {\n  background: #ede7f6;\n  color: #5e35b1;\n}\n\n.tasty-number-cell {\n  text-align: left;\n  font-family: 'Courier New', monospace;\n  color: #555;\n}\n\n.tasty-number-cell.positive {\n  color: #2e7d32;\n  font-weight: 600;\n}\n\n.tasty-number-cell.negative {\n  color: #d32f2f;\n  font-weight: 600;\n}\n\n.tasty-number-cell.muted {\n  color: #aaa;\n}\n\n.tasty-pnl-note {\n  display: block;\n  font-size: 0.7rem;\n  color: #999;\n  font-weight: 400;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.tasty-loading, .tasty-error, .tasty-empty-state {\n  text-align: center;\n  padding: 3rem 2rem;\n  font-size: 1.1rem;\n}\n\n.tasty-error {\n  color: #d32f2f;\n  background-color: #ffebee;\n  border-radius: 4px;\n  border: 1px solid #ffcdd2;\n}\n\n.tasty-empty-state {\n  color: #666;\n  background: white;\n  border-radius: 8px;\n  padding: 4rem 2rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n@media (max-width: 1200px) {\n  .tasty-table th,\n  .tasty-table td {\n    padding: 8px 5px;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .tasty-container {\n    padding: 0.25rem;\n  }\n\n  .tasty-table-container {\n    font-size: 0.75rem;\n  }\n\n  .tasty-table th,\n  .tasty-table td {\n    padding: 6px 4px;\n    font-size: 0.75rem;\n  }\n\n  .tasty-underlying-cell {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
